class runExportController {

  constructor(modalLoaderService, extractsService, customer, customerIntegrationsService) {
    this.name = 'runExport';
    this.modalLoaderService = modalLoaderService;
    this.extractsService = extractsService;
    this.customer = customer;
    this.customerIntegrationsService = customerIntegrationsService;
    this.isRequestCompleted = false;
    this.isRequestFailure = false;
    this.showBtn = false;
    this.getIntegrationsForSchemas();
  }

  cancel() {
    this.modalLoaderService.close();
  }

  runExport() {
    let customerId = this.customer.id;
    this.extractsService.createExtract(customerId).then(
      this.onRunExportSuccess.bind(this),
      this.onRunExportFailure.bind(this)
    );
  }
  getIntegrationsForSchemas() {
    this.customerIntegrationsService.getAllIntegrations({
      customerId: this.customer.id
    }).then((agentConfig) => {
      if(agentConfig) {
        agentConfig.data.content.forEach((element)=>{
          if(element.key === 'licensingType' && element.value === 'BUIP+') {
            this.showBtn = true;
          }
        });
      }
    });
  }

  onRunExportSuccess() {
    this.isRequestCompleted = true;
  }

  onRunExportFailure() {
    this.isRequestFailure = true;
  }
}

runExportController.$inject = ['modalLoaderService', 'extractsService', 'customer', 'customerIntegrationsService'];

export
default runExportController;



// WEBPACK FOOTER //
// ./app/components/runExport/runExport.controller.js